// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"8ffc8928","95":"c7978061"}[chunkId] + ".chunk.css";
};